import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./Invoice.css";

const InvoiceTemplate = () => {
  const invoiceRef = useRef();

  const handleDownloadPdf = () => {
    const input = invoiceRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };

  return (
    <div>
      <button onClick={handleDownloadPdf}>Download PDF</button>

      <div className="invoice-wrapper" ref={invoiceRef}>
        <div className="invoice-container">
          
          {/* HEADER */}
<div className="invoice-header">
  <div className="logo-section">
    <img
      src={process.env.PUBLIC_URL + "/rekonic-logo.jpg"}
      alt="Rekonic Logo"
      className="logo"
    />
  </div>

  <div className="invoice-meta">
    <h3>INVOICE#: IV-001</h3>
    <p>07 Apr 2021 8:10 am</p>
  </div>
</div>

          <h2 className="invoice-title">TAX INVOICE</h2>

          {/* CUSTOMER + DATE SECTION */}
          <div className="invoice-info">
            <div className="customer-info">
              <h4>Paul Henderson</h4>
              <p>123 Peachtree St NE Atlanta, GA 30303</p>
              <p>paulhenderson@gmail.com</p>
              <p>397550278</p>
            </div>

            <div className="invoice-dates">
              <table>
                <thead>
                  <tr>
                    <th>Invoice Date</th>
                    <th>Amount</th>
                    <th>Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>05 April 2025</td>
                    <td>AED 4000.00</td>
                    <td>05 April 2026</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ITEMS TABLE */}
          <table className="items-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Details</th>
                <th>Amount</th>
                <th>Tax</th>
                <th>Discount</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Paul Henderson</td>
                <td>Air ticket</td>
                <td>4000.00</td>
                <td>10.00</td>
                <td>5.00</td>
                <td>3800.00</td>
              </tr>
            </tbody>
          </table>

          {/* TOTAL SECTION */}
          <div className="totals">
            <p><strong>Total Tax (AED):</strong> 5.00</p>
            <p><strong>Total Amount (AED):</strong> 3800.00</p>
            <p><strong>Amount in Words:</strong> Three Thousand Eight Hundred</p>
          </div>

          <div className="signature-section">
  <div className="signature-container">
    <p>Authorised Signature</p>
    <div className="signature-box"></div>
  </div>

  {/* STAMP NEXT TO SIGNATURE */}
  <img src={process.env.PUBLIC_URL + "/stamp.jpg"} alt="Stamp" className="stamp" />
</div>

          {/* BANK DETAILS */}
          <div className="bank-section">
            <h4>BANK ACCOUNT INFORMATION</h4>
            <table>
              <tbody>
                <tr>
                  <td>Account Title</td>
                  <td>Suwah Travels</td>
                </tr>
                <tr>
                  <td>Account Number</td>
                  <td>54654646</td>
                </tr>
                <tr>
                  <td>Bank Name</td>
                  <td>ADCB</td>
                </tr>
                <tr>
                  <td>Branch</td>
                  <td>Dubai</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FOOTER */}
          <div className="footer-note">
            <p>
              This is a Computer Generated Document and does not require any official signature.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
